import { Injectable } from '@angular/core';
import { LayoutTunnels } from '../classes/layout-tunnels.abstract';
import {HelpAndSupportComponent} from "@ispm/shared/components/help-and-support/help-and-support.component";


@Injectable()
export class PanelsService extends LayoutTunnels {

  public openHelpAndSupportPanel(supportName) {
    return this.showLayout(HelpAndSupportComponent,{approveCallback:null,payload:null}, supportName);
  }

  constructor() {
    super();
  }


}
